import { useEffect, useState, useRef } from "react";
// MUI
import { Grid2 } from "@mui/material";
// Styling
import styles from "./CreateSite.module.scss";
// Local imports
import SiteTypes from "../Components/SiteTypes/SiteTypes";
import SelectType from "../Components/SelectType/SelectType";
import WordpressLoginDetails from "../Components/WordpressLoginDetails/WordpressLoginDetails";
import Reviewpage from "../Components/Reviewpage/Reviewpage";
import ProcessingPage from "../Components/ProcessingPage/ProcessingPage";
import ReadyPage from "../Components/ReadyPage/ReadyPage";
import {
  EmptyStateCreateSite,
  selectedTypeData,
  SITE_MESSAGES,
} from "../Components/ConstantData/CreateSiteConstantData";
import CloneSite from "../Components/CloneSite/CloneSite";
import BlueprintSite from "../Components/BlueprintSite/BlueprintSite";
import CustomButton from "../../../../../GlobalComponents/CustomButton/CustomButton";
import { Actions } from "../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../Utils/storeUtils";
import { useSelector } from "react-redux";
import FailedPage from "../Components/FailedPage/FailedPage";
import PageLoading from "../../../../../GlobalComponents/PageLoading/PageLoading";
import { useParams } from "react-router-dom";
import NewEmptyState from "../../../../../GlobalComponents/EmptyState/NewEmptyState";
import { ReactComponent as Clonesite } from "../../../../../GlobalAssets/svg/clonesite12.svg";
import { useNavigate } from "react-router-dom";
import { useMakeApiCalls } from "../../../../../Hooks/useMakeApiCalls";
import { useEmailId } from "../../../../../Utils/utils";
import {
  buildsV1Sites,
  verifySshPassword,
} from "../../../../../Utils/roconConstants";
import RecommendedPlugins from "../Components/WordPressPlugins/WordPressPlugins";
import CurrentSiteInfo from "../../../../../GlobalComponents/CurrentSiteInfo/CurrentSiteInfo";
import SiteDetails from "../../../../../GlobalComponents/MigrateSiteDetails/MigrateSiteDetails";
import PlanExpiredCard from "../../../../../GlobalComponents/PlanExpiredCard/PlanExpiredCard";
import {
  siteData,
  getFilteredSiteData,
} from "../Components/ConstantData/CreateSiteConstantData";

export default function CreateSite() {
  const navigate = useNavigate();
  const [showType, setShowType] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [installationType, setInstallationType] = useState(null);
  const [showEnvironment, setShowEnvironment] = useState(false);
  const [step, setStep] = useState(1);
  const [cloneSite, setCloneSite] = useState(null);
  const [preselectedFromURL, setPreselectedFromURL] = useState(false);
  const [blueprint, setBlueprint] = useState(null);
  const [showReadyPage, setShowReadyPage] = useState(false);
  const [showFailedPage, setShowFailedPage] = useState(false);
  const [nameLoading, setNameLoading] = useState(false);
  const [nameValid, setNameValid] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isMigrateSite, setIsMigrateSite] = useState(false);
  const [isMultisite, setIsMultisite] = useState("");
  const [hasImportantDirs, setHasImportantDirs] = useState("");
  const maxLength = 25;
  const minLength = 3;
  const params = useParams();
  let orgId = parseInt(params.orgId);
  const [pluginCard, setPluginCard] = useState([]);

  const [isCurrentHosting, setISCurrentHosting] = useState({
    currenthosting: "",
    currenthostingerror: false,
    specifydirectory: "",
    specifydirectoryerror: false,
  });

  const [wpAdmin, setWpAdmin] = useState({
    wpadminurl: "",
    wpadminurlerror: false,
    wpadminurlsuffix: "/wp-admin",
    wpadminusername: "",
    wpadminusernameerror: false,
    wpadminpassword: "",
    wpadminpassworderror: false,
  });

  const [siteTypes, setSiteTypes] = useState({
    // CloneSite
    siteCloneName: "",
    clonedSiteId: "",
    // BlueprintSite
    blueprintId: "",
    // installationtype
    installationtype: "",
  });

  const [isInput, setIsInput] = useState({
    sitename: "",
    sitenameerror: false,
    sitenameErrorMessage: "Site already exists!",
    tempdomainname: "",
    tempdomainsuffix: `.${process.env.REACT_APP_TEMP_DOMAIN}`,
    tempdomainnameerror: false,
    wordpresspassword: "",
    wordpresspassworderror: false,
    wordpresspasswordErrorMessage:
      "Requires at least 8 characters with one capital letter, one numeric character, and one special character",
    wordpressusername: "",
    wordpressusernameerror: false,
    wordpressconfirmpassword: "",
    wordpressconfirmpassworderror: false,
    wordpressconfirmpassworderrormessage: "",
    // Development
    tempdomainnamedev: "",
    tempdomainnamedeverror: false,
    tempdomainnamedevErrorMessage: "Temporary domain already exists!",
    wordpresspassworddev: "",
    wordpresspassworddeverror: false,
    wordpressusernamedev: "",
    wordpressusernamedeverror: false,
    // wordpressconfirmpassworddev: "",
    // wordpressconfirmpassworddeverror: false,
    waf: true,
    // SSH password (every EBS/v2 site has SSH; set at creation only)
    sshpassword: "",
    sshpassworderror: false,
  });

  useMakeApiCalls(() => {
    getStore().dispatch({
      type: Actions.API_ALL_PLANS,
    });
  });

  const plans = useSelector(
    (state) => state.plansInfo.allPlans?.features?.licenses,
  );

  const stagingPlan = plans?.find((plan) => plan.licenseType === "Staging");
  const priceId = stagingPlan?.pricing?.[0]?.stripePriceId;

  // useSelector
  const blueprintInfo = useSelector(
    (state) => state.bluePrintInfo.userOrgBluePrints?.data,
  );
  const sitesInfo = useSelector((state) => state.sitesInfo);
  const selectedOrg = useSelector(
    (state) => state.organizationsInfo?.selectedOrg,
  );
  const specificPlan = useSelector((state) => state.plansInfo?.specificPlan);
  const noPlan = specificPlan?.specificPlans;

  const dashboardOrg = useSelector(
    (state) => state.organizationsInfo?.dashboardOrg?.data,
  );
  const isParentOrg = selectedOrg?.parentOrgName === null;
  const isPartOfParentOrg =
    selectedOrg?.parentOrgName !== null
      ? dashboardOrg?.some((org) => org?.name === selectedOrg?.parentOrgName)
      : true;

  const userDetails = useSelector((state) => state.users?.userDetails);

  // let orgId = selectedOrg?.orgId ? selectedOrg?.orgId : -1;

  useEffect(() => {
    if (sitesInfo?.sitesList?.data) {
      // Check if sitesInfo is available (API resolved)
      setIsLoading(false);
    }
  }, [sitesInfo?.sitesList?.data]);

  useEffect(() => {
    setIsLoading(true);
    getStore().dispatch({ type: Actions.API_ORG_DASHBOARD });
    getStore().dispatch({
      type: Actions.API_GET_ALL_BLUEPRINT,
      data: { orgId: orgId },
      meta: {
        onSuccess: () => {},
        onError: () => {},
      },
    });
    getStore().dispatch({
      type: Actions.API_SITES_LIST,
      data: { orgId: orgId },
      meta: {
        onSuccess: () => {
          setIsLoading(false);
        },
        onError: () => {
          setIsLoading(false);
        },
      },
    });
    getStore().dispatch({
      type: Actions.API_GET_SEPCIFIC_PLAN,
      data: { orgId: orgId },
      meta: {
        onSuccess: () => {
          setIsLoading(false);
        },
        onError: () => {
          setIsLoading(false);
        },
      },
    });
  }, [orgId]);

  useMakeApiCalls(() => {
    getStore().dispatch({
      type: Actions.API_STAGING_TIMESTAMP,
      data: {
        orgId: orgId,
        siteId: 0,
      },
    });
  });

  // bluePrints Sites
  const blueprintDetails = () => {
    const getBlueprintDetail = (blueArray) => {
      return blueArray?.map((blue) => ({
        title: blue?.blueprintName,
        icon: blue?.imagePath,
        blueprintId: blue.blueprintId,
        siteType: blue.siteType,
      }));
    };

    return blueprintInfo?.length > 0 ? getBlueprintDetail(blueprintInfo) : [];
  };

  const blueprintData = blueprintDetails();

  // clone Sites
  const cloneDetails = () => {
    const getCloneDetail = (cloneArray) => {
      return cloneArray?.map((clone) => ({
        title: clone.siteName,
        icon: clone.imagePath,
        siteId: clone.siteId,
        installType: clone.installType,
      }));
    };

    const cloneSites = sitesInfo?.sitesList?.data;

    return cloneSites?.length > 0 ? getCloneDetail(cloneSites) : [];
  };

  const cloneSiteData = cloneDetails();

  const emailId = useEmailId();

  const SiteDetailsFlushState = () => {
    setIsMultisite(null);
    setHasImportantDirs(null);
    setISCurrentHosting({
      currenthosting: "",
      currenthostingerror: false,
      specifydirectory: "",
      specifydirectoryerror: false,
    });
    setWpAdmin({
      wpadminurl: "",
      wpadminurlerror: false,
      wpadminusername: "",
      wpadminusernameerror: false,
      wpadminpassword: "",
      wpadminpassworderror: false,
    });
  };

  // flushStateVariables
  const flushStateVariables = () => {
    setSelectedType(null);
    setInstallationType(null);
    setCloneSite(null);
    setBlueprint(null);
    setIsMultisite(null);
    setHasImportantDirs(null);
    setPluginCard([]);
    setShowEnvironment(false);
    setIsInput({
      ...isInput,
      sitenameerror: false,
      sitename: "",
      tempdomainnameerror: false,
      tempdomainname: "",
      wordpressusernameerror: false,
      wordpressusername: "",
      wordpresspassworderror: false,
      wordpresspassword: "",
      wordpressconfirmpassworderror: false,
      wordpressconfirmpassword: "",
      tempdomainnamedev: "",
      tempdomainnamedeverror: false,
      wordpresspassworddev: "",
      wordpresspassworddeverror: false,
      wordpressusernamedev: "",
      wordpressusernamedeverror: false,
      wordpressconfirmpassworddev: "",
      wordpressconfirmpassworddeverror: false,
      sshpassword: "",
      sshpassworderror: false,
    });
    setSiteTypes({
      ...siteTypes,
      siteCloneName: "",
      clonedSiteId: "",
      blueprintId: "",
      installationtype: "",
    });
    SiteDetailsFlushState();
  };

  const isInputValidation = () => {
    if (
      isInput &&
      isInput.sitenameerror !== true &&
      isInput.wordpressusernameerror !== true &&
      isInput.wordpresspassworderror !== true &&
      isInput.wordpressconfirmpassworderror !== true &&
      isInput.wordpresspassword === isInput.wordpressconfirmpassword &&
      isInput.sitename !== "" &&
      isInput.wordpressusername !== "" &&
      isInput.wordpresspassword !== "" &&
      isInput.wordpressconfirmpassword !== "" &&
      isInput.sitename?.length > 0 &&
      isInput.sitename?.length > minLength &&
      isInput.sitename?.length < maxLength &&
      nameLoading !== true &&
      nameValid === true &&
      (showEnvironment ? isInputValidationdev() : true) &&
      (sshRequired
        ? verifySshPassword(isInput.sshpassword, isInput.wordpresspassword)
        : true)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isInputValidationdev = () => {
    if (
      isInput &&
      isInput.tempdomainnamedeverror !== true &&
      isInput.wordpressusernamedeverror !== true &&
      isInput.wordpresspassworddeverror !== true &&
      //isInput.wordpressconfirmpassworddeverror !== true &&
      (isInput.tempdomainnamedev === isInput.sitename) !== true &&
      isInput.tempdomainnamedev !== "" &&
      isInput.wordpressusernamedev !== "" &&
      isInput.wordpresspassworddev !== "" &&
      //isInput.wordpressconfirmpassworddev !== "" &&
      isInput.tempdomainnamedev?.length > 0 &&
      isInput.tempdomainnamedev?.length > minLength &&
      isInput.tempdomainnamedev?.length < maxLength &&
      (isInput.tempdomainnamedev === isInput.sitename) !== ""
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isInputValidationforDedicatedHosting = () => {
    if (
      isInput &&
      isInput.sitenameerror !== true &&
      isInput.sitename !== "" &&
      isInput.sitename?.length > 0 &&
      isInput.sitename?.length > minLength &&
      isInput.sitename?.length < maxLength &&
      nameLoading !== true
    ) {
      return true;
    } else {
      return false;
    }
  };

  const dedicatedHosting = useSelector(
    (state) => state.plansInfo?.specificPlan?.isDedicated === true,
  );
  // every new managed (v2) site gets SSH, so its password is part of the form
  const sshRequired = !dedicatedHosting && !buildsV1Sites(orgId);

  const basePlan =
    specificPlan?.specificPlans?.find((lic) => lic.basePlan === true) || {};
  const cancel = basePlan?.cancel;
  const daysAfterExpiry = basePlan?.daysAfterExpiry;
  const isSingleSite = basePlan?.isSingleSite;
  const filteredSiteData = getFilteredSiteData(
    siteData,
    // dedicatedHosting,
    isSingleSite,
  );

  const getSiteData = (siteType) => {
    const parentOrgName = specificPlan?.parentOrgId;
    const sites = specificPlan?.specificPlans?.filter(
      (lic) => lic.licenseType === siteType,
    );
    const site = sites?.[0];
    const totalQuantity = sites?.reduce(
      (total, lic) => total + lic.quantity,
      0,
    );
    const usedSite = site?.featureDetails?.find(
      (feature) => feature.type === "NUM_SITES",
    );

    return {
      parent: parentOrgName,
      licenseId: site?.licenseId,
      isSingleSite: site?.isSingleSite,
      quantity: totalQuantity,
      used: parseInt(usedSite?.used) || 0,
      limitOrAvailablity: parseInt(usedSite?.limitOrAvailablity) || 0,
    };
  };

  const additionalSite = useSelector(() => getSiteData("Additional Site"));
  const performQuantity = useSelector(() => getSiteData("Performance Sites"));

  const licence = specificPlan?.specificPlans.find(
    (lic) => lic.licenseType !== "Waf" && lic.licenseType !== "Additional Site",
  );

  // Find the feature with type 'NUM_SITES'
  const numSitesFeature = licence?.featureDetails.find(
    (feature) => feature.type === "NUM_SITES",
  );

  const bundleId = licence?.featureDetails.find(
    (feature) => feature.type === "LIGHTSAIL_BUNDLE_ID",
  );

  const recommendedPlugins = pluginCard
    .map((plugin) => plugin.header)
    .join(",")
    .toLowerCase();

  // triggerBuild function
  const triggerBuild = async () => {
    if (!licence) {
      console.error("Error: No valid license found!");
      return;
    }
    const isPerformanceSite =
      selectedTypeData[selectedType]?.title === "Performance site";

    let createSitePayload = {
      jobName: "Buildsite",
      installType: siteTypes?.installationtype,
      selectedPlanId: licence?.licenseId,
      bundleId: bundleId?.limitOrAvailablity,
      isSingleSite:
        siteTypes?.installationtype === "Single Site" ? true : false,
      buildParams: {
        SITENAME: isInput?.sitename?.toLowerCase(),
        SERVICENAMEPREFIX: `${isInput?.tempdomainname?.toLowerCase()}`,
        WPUSERID:
          isInput?.wordpressusername?.toLowerCase() +
          "_" +
          isInput?.sitename?.toLowerCase(),
        WPPASSWORD: isInput?.wordpresspassword,
        BLUEPRINT: siteTypes?.blueprintId > 0,
        BLUEPRINTID: siteTypes?.blueprintId ? siteTypes?.blueprintId : "",
        SITECLONE: siteTypes?.clonedSiteId > 0,
        CLONEDSITEID: siteTypes?.clonedSiteId ? siteTypes.clonedSiteId : "",
        WAF: isInput.waf === true,
        DEVELOPMENT: showEnvironment !== undefined ? showEnvironment : false,
        DEVDOMAINNAME: isInput?.tempdomainnamedev?.toLowerCase(), //"myroconapp",
        DEVWPUSERID:
          isInput?.wordpressusernamedev?.toLowerCase() +
          "_" +
          isInput?.tempdomainnamedev?.toLowerCase(),
        DEVWPPASSWORD: isInput?.wordpresspassworddev,
        ORGID: orgId,
        RECOMMENDEDPLUGINS: recommendedPlugins ? recommendedPlugins : null,
        PERFORMANCEID: isPerformanceSite ? performQuantity.licenseId : "",
        MIGRATESITEDETAILS: isMigrateSite,

        REQUESTEDBY: emailId,
        CURRENTHOSTING: isCurrentHosting.currenthosting,
        ISMULTISITE: isMultisite,
        IMPDIRECTORIES: hasImportantDirs,
        IMPDIRECTORIESINFO: isCurrentHosting.specifydirectory,
        ADMINURL: wpAdmin.wpadminurl,
        ADMINUSERNAME: wpAdmin.wpadminusername,
        ADMINPASSWORD: wpAdmin.wpadminpassword,
        // SSH login of every v2 site (ebs-Buildsite SSH_PASSWORD); never logged or stored
        ...(sshRequired ? { SSH_PASSWORD: isInput?.sshpassword } : {}),
      },
    };
    getStore().dispatch({
      type: Actions.API_CREATE_SITE,
      data: createSitePayload,
      meta: {
        onSuccess: () => {
          setShowReadyPage(true);
          flushStateVariables();
        },
        onError: () => {
          setShowFailedPage(true);
          flushStateVariables();
        },
      },
    });
  };

  const handleSelect = (field) => (selectedId, siteCloneName, installType) => {
    setSiteTypes((prev) => ({
      ...prev,
      [field]: selectedId,
      siteCloneName: siteCloneName,
      ...(installType && { installationtype: installType }),
    }));
  };

  const handleInstallationTypeSelect = handleSelect("installationtype");
  const handleBlueprintSelect = handleSelect("blueprintId");
  const handleCloneSiteSelect = handleSelect("clonedSiteId", "siteCloneName");

  // pre-select clone/blueprint from URL params
  const search = window?.location?.search;
  const searchParams = new URLSearchParams(search);
  useEffect(() => {
    if (!search) return;

    const cloneId = searchParams.get("cloneSiteId");
    const blueprintId = searchParams.get("blueprintId");

    // Handle Clone Site
    if (cloneId && Array.isArray(cloneSiteData) && cloneSiteData.length > 0) {
      const idx = cloneSiteData.findIndex(
        (s) => String(s.siteId) === String(cloneId),
      );

      if (idx !== -1) {
        const site = cloneSiteData[idx];

        const type =
          filteredSiteData?.find((d) => d.title === "Clone Site") ?? null;

        setShowType(
          type
            ? {
                title: type.title,
                description: type.description,
                icon: type.icon,
                installationtype: site.installType,
              }
            : { title: "Clone Site" },
        );

        setCloneSite(idx);
        setSiteTypes((prev) => ({
          ...prev,
          clonedSiteId: site.siteId,
          siteCloneName: site.title,
          installationtype: site.installType,
        }));
        setPreselectedFromURL(true);
        return; // stop if clone handled
      }
    }

    // Handle Blueprint Site
    if (
      blueprintId &&
      Array.isArray(blueprintData) &&
      blueprintData.length > 0
    ) {
      const idx = blueprintData.findIndex(
        (b) => String(b.blueprintId) === String(blueprintId),
      );

      if (idx !== -1) {
        const bp = blueprintData[idx];

        const type =
          filteredSiteData?.find((d) => d.title === "Blueprint Site") ?? null;

        setShowType(
          type
            ? {
                title: type.title,
                description: type.description,
                icon: type.icon,
                installationtype: bp.siteType,
              }
            : { title: "Blueprint Site" },
        );

        setBlueprint({
          index: idx,
          blueprintId: bp.blueprintId,
          title: bp.title,
          installationtype: bp.siteType,
        });
        setSiteTypes((prev) => ({
          ...prev,
          blueprintId: bp.blueprintId,
          installationtype: bp.siteType,
        }));
        setPreselectedFromURL(true);
      }
    }
  }, [cloneSiteData.length, blueprintData.length]);

  // Helper function to get messages for each step
  const getMessage = (siteType) => {
    if (
      (showType?.title === "New Wordpress Site" && step === 5) ||
      (showType?.title !== "New Wordpress Site" && step === 4)
    ) {
      return showReadyPage
        ? SITE_MESSAGES[siteType][4].complete
        : SITE_MESSAGES[siteType][4].inProgress;
    } else if (step === 5) {
      return showReadyPage
        ? SITE_MESSAGES[siteType][5].complete
        : SITE_MESSAGES[siteType][5].inProgress;
    }
    return SITE_MESSAGES[siteType][step];
  };

  // Handle Back button functionality
  const handleBack = () => {
    const hasParams =
      searchParams.has("cloneSiteId") || searchParams.has("blueprintId");

    if (step === 5) {
      setStep(4);
    } else if (step === 4) {
      setStep(3);
    } else if (step === 3) {
      if (showType?.title === "New Wordpress Site") {
        setStep(1);
      } else {
        setStep(2);
      }
    } else if (step === 2) {
      setStep(1);
    } else {
      flushStateVariables();
      setShowType(null);
      if (hasParams) {
        searchParams.delete("cloneSiteId");
        searchParams.delete("blueprintId");
        navigate(`${window.location.pathname}?${searchParams.toString()}`, {
          replace: true,
        });
      }
    }
  };

  // Handle Next button functionality
  const handleNext = () => {
    // setAttemptedSubmit(false);
    const isValidInput = dedicatedHosting
      ? isInputValidationforDedicatedHosting()
      : isInputValidation();
    if (step === 1) {
      if (showType?.title === "New Wordpress Site") {
        if (
          selectedType !== null &&
          selectedType !== 2 &&
          installationType !== null
        ) {
          setStep(3);
        }
      } else if (showType?.title === "Migrate Site") {
        if (step === 1) {
          setStep(2);
          setIsMigrateSite(true);
        }
      } else if (showType?.title === "Clone Site" && cloneSite !== null) {
        setStep(2);
      } else if (showType?.title === "Blueprint Site" && blueprint !== null) {
        setStep(2);
      }
    // } else if (showType?.title === "New Wordpress Site" && step === 2) {
    //   if (pluginCard !== null) {
    //     setStep(3);
    //   } else {
    //     setStep(3);
    //   }
    } else if (
      (showType?.title !== "New Wordpress Site" && step === 2) ||
      (showType?.title === "New Wordpress Site" && step === 3)
    ) {
      if (isValidInput) {
        if (showType?.title !== "New Wordpress Site" && step === 2) {
          setStep(3);
        } else if (showType?.title === "New Wordpress Site" && step === 3) {
          setStep(4);
        }
      }
    } else if (
      (showType?.title === "New Wordpress Site" && step === 4) ||
      (showType?.title !== "New Wordpress Site" && step === 3)
    ) {
      if (showType?.title === "New Wordpress Site" && step === 4) {
        triggerBuild();
        setStep(5);
      } else if (showType?.title !== "New Wordpress Site" && step === 3) {
        triggerBuild();
        setStep(4);
      }
    }
  };

  // Disabled functionality
  const isDisabledDH = dedicatedHosting
    ? !isInputValidationforDedicatedHosting()
    : !isInputValidation();
  const isNextDisabled =
    showType?.title === "New Wordpress Site"
      ? (step === 1 &&
          (selectedType === null ||
            selectedType === 2 ||
            installationType === null)) ||
        // (step === 2 && !pluginCard?.length === 0) ||
        (showType?.title === "New Wordpress Site" && step === 3 && isDisabledDH)
      : showType?.title === "Migrate Site"
        ? (step === 1 &&
            (isCurrentHosting.currenthosting === "" ||
              isMultisite === null ||
              (hasImportantDirs === true &&
                isCurrentHosting.specifydirectory === "") ||
              wpAdmin.wpadminurl === "" ||
              wpAdmin.wpadminusername === "" ||
              wpAdmin.wpadminpassword === "")) ||
          (step === 2 && isDisabledDH)
        : showType?.title === "Clone Site"
          ? (step === 1 && cloneSite === null) || (step === 2 && isDisabledDH)
          : showType?.title === "Blueprint Site"
            ? (step === 1 && blueprint === null) || (step === 2 && isDisabledDH)
            : false;

  //enter key functionality
  const containerRef = useRef(null);
  // const [attemptedSubmit, setAttemptedSubmit] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.key === "Enter" &&
        !isNextDisabled &&
        showType &&
        event.target.tagName !== "TEXTAREA" &&
        event.target.tagName !== "BUTTON"
      ) {
        event.preventDefault();
        // setAttemptedSubmit(true);
        handleNext();
      } else if (
        event.key === "Enter" &&
        isNextDisabled &&
        showType &&
        event.target.tagName !== "TEXTAREA" &&
        event.target.tagName !== "BUTTON"
      ) {
        event.preventDefault();
        // setAttemptedSubmit(true);
      }
    };

    const refCurrent = containerRef.current;
    if (refCurrent) {
      refCurrent.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, [
    isNextDisabled,
    showType,
    step,
    selectedType,
    installationType,
    pluginCard,
    isInput,
    cloneSite,
    blueprint,
  ]);

  useEffect(() => {
    if (selectedType === 1) {
      setInstallationType(null);
    } else if (selectedType === 0) {
      setInstallationType(null);
    }
  }, [selectedType]);

  return (
    <>
      {isLoading && plans ? (
        <PageLoading />
      ) : (
        <>
          <Grid2
            className={styles.CreateSiteContainer}
            ref={containerRef}
            tabIndex={0}
          >
            {noPlan?.length === 0 && (
              <NewEmptyState
                header={EmptyStateCreateSite.header}
                subHeader={EmptyStateCreateSite.subHeader}
                icon={Clonesite}
                title={
                  <span>
                    Launch Your <span style={{ color: "#135FC2" }}>First</span>{" "}
                    WordPress Site
                  </span>
                }
                subTitle={EmptyStateCreateSite.subTitle}
              />
            )}
            <Grid2 className={styles.headerFlexBox}>
              {noPlan?.length > 0 && (
                <Grid2
                  className={`${styles.header} ${
                    showFailedPage ? styles.failedText : ""
                  }`}
                >
                  {((showType?.title === "New Wordpress Site" && step === 5) ||
                    (showType?.title !== "New Wordpress Site" && step === 4)) &&
                  !showReadyPage &&
                  !showFailedPage
                    ? "Your site is being processed..."
                    : showReadyPage
                      ? "Well Done, You are Ready!"
                      : showFailedPage
                        ? "Something Went Wrong"
                        : "Create Site"}
                </Grid2>
              )}
              {!showType && noPlan?.length > 0 && (
                <Grid2 className={styles.SubHeader}>
                  Set up your WordPress site effortlessly with hosting optimized
                  for performance and growth.
                </Grid2>
              )}
              {(showType?.title === "Migrate Site" ||
                showType?.title === "Clone Site" ||
                showType?.title === "Blueprint Site") && (
                <Grid2 className={styles.SubHeader}>
                  {getMessage("siteHeader")}
                </Grid2>
              )}
              {showType?.title === "New Wordpress Site" && (
                <Grid2 className={styles.SubHeader}>
                  {getMessage("newWordpressSite")}
                </Grid2>
              )}
            </Grid2>
            {noPlan?.length > 0 && (
              <>
                {!showType?.title && (
                  <Grid2 className={styles.types}>
                    <SiteTypes
                      siteData={filteredSiteData}
                      selectedType={selectedType}
                      setSelectedType={setSelectedType}
                      setShowType={setShowType}
                      flushStateVariables={flushStateVariables}
                      cloneSiteData={cloneSiteData}
                      blueprintData={blueprintData}
                      selectedOrg={selectedOrg}
                      noPlan={noPlan}
                      numSitesFeature={numSitesFeature}
                      basePlan={basePlan}
                      orgId={orgId}
                      additionalSite={additionalSite}
                      isPartOfParentOrg={isPartOfParentOrg}
                    />
                  </Grid2>
                )}
              </>
            )}
            {showType?.title === "New Wordpress Site" && step === 1 && (
              <Grid2 className={styles.backgroundColor}>
                <SelectType
                  selectedType={selectedType}
                  setSelectedType={setSelectedType}
                  installationType={installationType}
                  setInstallationType={setInstallationType}
                  onInstallationTypeSelect={handleInstallationTypeSelect}
                  performQuantity={performQuantity}
                  performButton={() => {
                    navigate(`/account/${orgId}/add-on`);
                  }}
                  isSingleSite={isSingleSite}
                  setPluginCard={setPluginCard}
                  isParentOrg={isParentOrg}
                  orgId={orgId}
                  dedicatedHosting={dedicatedHosting}
                />
              </Grid2>
            )}
            {/* showType?.title === "New Wordpress Site" && step === 2 && (
              <Grid2 className={styles.backgroundColor}>
                <RecommendedPlugins
                  pluginCard={pluginCard}
                  setPluginCard={setPluginCard}
                />
              </Grid2>
            ) */}
            {showType?.title === "Migrate Site" && step === 1 && (
              <Grid2 className={styles.backgroundColor}>
                {/* <Migration
                  migration={migration}
                  isCurrentHosting={isCurrentHosting}
                  setISCurrentHosting={setISCurrentHosting}
                  isMultisite={isMultisite}
                  setIsMultisite={setIsMultisite}
                  hasImportantDirs={hasImportantDirs}
                  setHasImportantDirs={setHasImportantDirs}
                  wpAdmin={wpAdmin}
                  setWpAdmin={setWpAdmin}
                  SiteDetailsFlushState={SiteDetailsFlushState}
                /> */}
                <CurrentSiteInfo
                  isCurrentHosting={isCurrentHosting}
                  setISCurrentHosting={setISCurrentHosting}
                  isMultisite={isMultisite}
                  setIsMultisite={setIsMultisite}
                  hasImportantDirs={hasImportantDirs}
                  setHasImportantDirs={setHasImportantDirs}
                  isCreateSite={true}
                  installationType={installationType}
                  setInstallationType={setInstallationType}
                  onInstallationTypeSelect={handleInstallationTypeSelect}
                  userDetails={userDetails}
                />
                <SiteDetails
                  wpAdmin={wpAdmin}
                  setWpAdmin={setWpAdmin}
                  isCurrentHosting={isCurrentHosting}
                  hasImportantDirs={hasImportantDirs}
                  isMultisite={isMultisite}
                />
              </Grid2>
            )}
            {showType?.title === "Clone Site" && step === 1 && (
              <Grid2 className={styles.backgroundColor}>
                <CloneSite
                  cloneSite={cloneSite}
                  setCloneSite={setCloneSite}
                  cloneSiteData={cloneSiteData}
                  onCloneSiteSelect={handleCloneSiteSelect}
                  siteTypes={siteTypes}
                  sitesInfo={sitesInfo}
                />
              </Grid2>
            )}
            {showType?.title === "Blueprint Site" && step === 1 && (
              <Grid2 className={styles.backgroundColor}>
                <BlueprintSite
                  blueprint={blueprint}
                  setBlueprint={setBlueprint}
                  blueprintData={blueprintData}
                  onBlueprintSelect={handleBlueprintSelect}
                />
              </Grid2>
            )}
            {((showType?.title === "New Wordpress Site" && step === 3) ||
              (showType?.title !== "New Wordpress Site" && step === 2)) && (
              <Grid2 className={styles.backgroundColor}>
                <WordpressLoginDetails
                  showEnvironment={showEnvironment}
                  setShowEnvironment={setShowEnvironment}
                  isInput={isInput}
                  setIsInput={setIsInput}
                  nameLoading={nameLoading}
                  setNameLoading={setNameLoading}
                  nameValid={nameValid}
                  setNameValid={setNameValid}
                  selectedCountry={selectedOrg?.country}
                  orgId={orgId}
                  priceId={priceId}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  dedicatedHosting={dedicatedHosting}
                />
              </Grid2>
            )}
            {((showType?.title === "New Wordpress Site" && step === 4) ||
              (showType?.title !== "New Wordpress Site" && step === 3)) && (
              <Grid2 className={styles.backgroundColor}>
                <Reviewpage
                  showType={showType}
                  selectedType={selectedType}
                  installationType={installationType}
                  cloneSite={cloneSite}
                  blueprint={blueprint}
                  isInput={isInput}
                  showEnvironment={showEnvironment}
                  cloneSiteData={cloneSiteData}
                  pluginCard={pluginCard}
                  dedicatedHosting={dedicatedHosting}
                />
              </Grid2>
            )}
            {((showType?.title === "New Wordpress Site" && step === 5) ||
              (showType?.title !== "New Wordpress Site" && step === 4)) &&
              !showReadyPage &&
              !showFailedPage && (
                <Grid2 className={styles.backgroundColor}>
                  <ProcessingPage isInput={isInput} />
                </Grid2>
              )}
            {showReadyPage && (
              <Grid2 className={styles.backgroundColor}>
                <ReadyPage selectedOrg={selectedOrg} />
              </Grid2>
            )}
            {showFailedPage && (
              <Grid2 className={styles.backgroundColor}>
                <FailedPage selectedOrg={selectedOrg} />
              </Grid2>
            )}
            {((cancel === true && daysAfterExpiry >= 2) ||
              daysAfterExpiry >= 2) && (
              <PlanExpiredCard org={selectedOrg} plan={basePlan} />
            )}
          </Grid2>

          {showType &&
            ((showType?.title === "New Wordpress Site" && step !== 5) ||
              (showType?.title !== "New Wordpress Site" && step !== 4)) && (
              <Grid2 className={styles.bottom}>
                <Grid2 className={styles.buttonFlex}>
                  <Grid2 className={styles.Back} onClick={handleBack}>
                    Back
                  </Grid2>
                  <CustomButton
                    className={styles.Next}
                    onClick={handleNext}
                    disabled={isNextDisabled}
                  >
                    {(() => {
                      // if (
                      //   showType?.title === "New Wordpress Site" &&
                      //   step === 2
                      // ) {
                      //   return pluginCard?.length === 0 ? "Skip" : "Next";
                      // } else
                      if (
                        (showType?.title === "New Wordpress Site" &&
                          step === 4) ||
                        (showType?.title !== "New Wordpress Site" && step === 3)
                      ) {
                        return "Create";
                      } else {
                        return "Next";
                      }
                    })()}
                  </CustomButton>
                </Grid2>
              </Grid2>
            )}
        </>
      )}
    </>
  );
}
